module.exports = __webpack_public_path__ + "assets/mei.5b86b961.svg";